exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vm--overlay[data-v-12579965]{background:#000;opacity:.7}.overlay-enter[data-v-12579965],.overlay-leave-to[data-v-12579965]{opacity:0}.overlay-enter-active[data-v-12579965],.overlay-leave-active[data-v-12579965]{transition:all .3s}", ""]);

// exports
